import React, { Fragment, useEffect, useState } from 'react';
import './../Resources/css/block_catering.css'
import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';
import CommonAPI from '../../../Shared/CommonAPI';

import { Container, Row, Col } from 'reactstrap';
import { TextBock, TextHeader, TextTitle } from '../../../Controls/Digital/TextHeaders';

import img_1 from '../Resources/Images/Catering/B&E.jpg';                                    
import img_2 from '../Resources/Images/Catering/Baked cheesecake.jpg';
import img_3 from '../Resources/Images/Catering/Brownies.jpg';                       
import img_4 from '../Resources/Images/Catering/Chicken wrap.jpg';                           
import img_5 from '../Resources/Images/Catering/Cinnamon Scrolls.jpg';                       
import img_6 from '../Resources/Images/Catering/Custard tart.jpg';                           
import img_7 from '../Resources/Images/Catering/Nutella macaroons.jpg';
import img_8 from '../Resources/Images/Catering/Pistachiodelish.jpg';                        
import img_9 from '../Resources/Images/Catering/Signoras Bakery hero 222.jpg';              
import img_10 from '../Resources/Images/Catering/Signoras Bakery hero.jpg';              
import img_11 from '../Resources/Images/Catering/Snithzel panini.jpg';                        
import img_12 from '../Resources/Images/Catering/Vanilla Slice.jpg';                          
import img_13 from '../Resources/Images/Catering/Veg Wrap.jpg';
import img_14 from '../Resources/Images/Catering/Yogurt.jpg';       

import img_15 from '../Resources/Images/Catering/BakingMix.jpeg';       
import img_16 from '../Resources/Images/Catering/Cakes.jpeg';       
import img_17 from '../Resources/Images/Catering/GreekCookies.jpeg';       
import img_18 from '../Resources/Images/Catering/LemonTart.jpeg';       
import img_19 from '../Resources/Images/Catering/MixedCookies.jpeg';       
import img_20 from '../Resources/Images/Catering/Scones.jpeg';       

import { AnimatedImage } from '../../../Controls/Digital/AnimatedImage';
import { ContactUsButton } from '../Components/ContactUsButton';

const Catering = (props) =>{

    const [blockName, setBlockName] = useState("");
    const [cateringItems, setCateringItems] = useState([]);
    const [addOns, setAddOns] = useState([]);
    const [canapes, setCanapes] = useState([]);
    const [cakes, setCakes] = useState([]);
    const [pies, setPies] = useState([]);
    const [piesLeft, setPiesLeft] = useState([]);
    const [piesRight, setPiesRight] = useState([]);

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);

        CommonAPI.getBakeryCateringItemsOnlyActive({}, getCateringItemsCallback);
        CommonAPI.getBakeryPiesOnlyActive({}, getPiesItemsCallback);
        CommonAPI.getBakeryAddOnsOnlyActive({}, getAddOnsItemsCallback);
        CommonAPI.getBakeryCanapesOnlyActive({}, getCanapesItemsCallback);
        CommonAPI.getBakeryCakesOnlyActive({}, getCakesItemsCallback);

    }, [setCateringItems, setPies, setAddOns, setCanapes, setCakes ]);

    let getCateringItemsCallback = (data) => {
        Common.log(data);
        setCateringItems(data);
    };
    let getPiesItemsCallback = (data) => {
        Common.log(data);
        setPies(data);

        var half_length = Math.ceil(data.length / 2);
        setPiesLeft(data.slice(0, half_length));
        setPiesRight(data.slice(half_length, data.length));
    };
    let getAddOnsItemsCallback = (data) => {
        Common.log(data);
        setAddOns(data);
    };
    let getCanapesItemsCallback = (data) => {
        Common.log(data);
        setCanapes(data);
    };
    let getCakesItemsCallback = (data) => {
        Common.log(data);
        setCakes(data);
    };

    return (
        <Block name="catering" isAlt={true}>

            <TextHeader text={
                <Fragment>
                    Catering & Events
                </Fragment>
            } />

            <TextTitle text={
                <Fragment>
                    Let us take care of your events
                </Fragment>
            } />

            <TextBock addClass="text-center" text={
                <Fragment>
                    <ContactUsButton />
                </Fragment>
            } />

            <TextBock lg={{ size: 8, offset: 2 }} text={
                <Fragment>
                    From casual to corporate lunch, birthday parties and Weddings we can design a custom catering solution for your specific needs.
                </Fragment>
            } />


            <Row>
                <Col><AnimatedImage image={img_1} /></Col>
                <Col><AnimatedImage image={img_2 } /></Col>
                <Col><AnimatedImage image={img_4} /></Col>
                <Col><AnimatedImage image={img_5 } /></Col>
                <Col><AnimatedImage image={img_6 } /></Col>
            </Row>

            <Row>
                <Col><AnimatedImage image={img_7} /></Col>
                <Col><AnimatedImage image={img_8} /></Col>
                <Col><AnimatedImage image={img_9} /></Col>
                <Col><AnimatedImage image={img_10} /></Col>
                <Col><AnimatedImage image={img_11} /></Col>
            </Row>

            <Row>
                <Col><AnimatedImage image={img_12} /></Col>
                <Col><AnimatedImage image={img_13} /></Col>
                <Col><AnimatedImage image={img_14} /></Col>
            </Row>


            <Row>
                <Col><AnimatedImage image={img_15} /></Col>
                <Col><AnimatedImage image={img_16} /></Col>
                <Col><AnimatedImage image={img_17} /></Col>
            </Row>

            <Row>
                <Col><AnimatedImage image={img_18} /></Col>
                <Col><AnimatedImage image={img_19} /></Col>
                <Col><AnimatedImage image={img_20} /></Col>
            </Row>

            <TextBock lg={{ size: 8, offset: 2 }} text={
                <Fragment>
                    Together with our sister business <span className="catering-highlight">Signora's Cafe</span>  we serve quality rustic authentic food for our amazing Illawara community.
                </Fragment>
            } />

            <Row>
                <Col>
                    <br />
                </Col>
            </Row>

            <TextTitle text={
                <Fragment>
                    Catering price list
                </Fragment>
            } />

            <Row>
                <Col lg={{ size: 6, offset: 4 }}>

                    {cateringItems.map((cateringItem, index) =>
                        <Fragment key={index}>
                            <p className="catering-header">
                                {cateringItem.name} - <span className="catering-price">{cateringItem.cost}</span>
                            </p>
                            <p className="catering-body">
                                {cateringItem.description}
                            </p>
                        </Fragment>
                    )}

                </Col>
            </Row>

            <Row>
                <Col lg={{ size: 5, offset: 2 }}>
                    <p className="catering-header">
                        Add Ons
                    </p>
                    <ul>
                        {addOns.map((addOn, index) =>
                            <Fragment key={index}>
                                <li>{addOn.name} <span className="catering-price">{addOn.cost}</span></li>
                            </Fragment>
                        )}
                    </ul>
                </Col>

                <Col lg="5">
                    <p className="catering-header">
                        Canapes
                    </p>
                    <ul>
                        {canapes.map((canape, index) =>
                            <Fragment key={index}>
                                <li>{canape.name} <span className="catering-price">{canape.cost}</span></li>
                            </Fragment>
                        )}
                    </ul>
                </Col>
            </Row>


            <TextTitle text={
                <Fragment>
                    Cakes
                </Fragment>
            } />

            <Row>
                <Col lg={{ size: 8, offset: 2 }} className="text-center">

                    {cakes.map((cake, index) =>
                        <Fragment key={index}>
                            <p className="catering-header">
                                {cake.name}
                            </p>
                            <p className="catering-body">
                                {cake.costCakeSize} <span className="catering-price">{cake.cost}</span>, {cake.costLargeCakeSize} <span className="catering-price">{cake.costLarge}</span> {cake.description}
                            </p>
                        </Fragment>
                    )}
                </Col>
            </Row>


            <TextTitle text={
                <Fragment>
                    Our Pies
                </Fragment>
            } />

            <Row>
                <Col lg={{ size: 5, offset: 2 }}>
                    <ul>
                        {piesLeft.map((pie, index) =>
                            <Fragment key={index}>
                                <li>{pie.name} <span className="catering-price">{pie.cost}</span></li>
                            </Fragment>
                        )}
                    </ul>
                </Col>

                <Col lg="5">
                    <ul>
                        {piesRight.map((pie, index) =>
                            <Fragment key={index}>
                                <li>{pie.name} <span className="catering-price">{pie.cost}</span></li>
                            </Fragment>
                        )}
                       
                    </ul>
                </Col>
            </Row>
        </Block>
    );
}
export default Catering;
